<script setup>
definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Dispute Handling";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Transaction",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">Search {{ pageTitle }}</h4>
  <VCard>
    <DisputeHandlingIndex />
  </VCard>
</template>
